import { FC } from "react";




const EoBNoteModal: FC<{ isModalVisible: boolean; hideModal: () => void; }> = ({ isModalVisible, hideModal }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between">
            <p className="modal-title" style={{color:'#008853', fontSize:'1.875rem'}}>
              Disclaimer
            </p>
            <button type="button" className="btn btn-sm btn-primary" aria-label="Close" onClick={hideModal}>
              Accept
            </button>
          </div>

          <div className="modal-body text-center">
            <p className="mb-3">
              IMPORTANT: By utilizing resources provided here (e.g., explanation of benefit (EOB) documents), you acknowledge that provided
              materials are informational only. Nothing contained in these resources should be construed to imply or guarantee coverage or
              appropriateness for any health or prescription drug benefit or other outcomes by any payer, and is not intended to replace or
              substitute for your professional medical judgement, diagnosis, treatment, or coding decisions. Additionally, the resources
              contained herein may not reflect the payer's current policies or practices, thus we urge you to independently verify current
              coverage information. You are solely responsible for your decisions and actions regarding medical care and reimbursement and
              for determining the accuracy and appropriateness of any diagnostic, clinical, or medical information you record or submit.
              Avertitas Pharma, Inc. makes no representations or warranties and expressly disclaims any and all liability concerning any
              treatment, reimbursement submission, actions by, or effect on any person based on information provided herein. Reliance on
              information herein is solely at your own risk, and you agree not to make any claims or statements that conflict with any of the
              foregoing. Finally, access to this database is tracked and may be reviewed by Averitas Pharma as needed for business purposes.
            </p>            
          </div>
        </div>
      </div>
    </div>
  )
}

export default EoBNoteModal
